<template>
  <div class="charts">
    <div class="select-searchmain1">
      <div class="earch-input">
        <div class="  ">
          <!-- <p>查询日期：</p> -->

          <el-date-picker
            :clearable="false"
            v-model="searchParams.startYear"
            :picker-options="startDatePicker"
            value-format="yyyy"
            type="year"
            placeholder="开始时间"
          >
          </el-date-picker>
          ~
          <el-date-picker
            :clearable="false"
            v-model="searchParams.endYear"
            :picker-options="endDatePicker"
            value-format="yyyy"
            type="year"
            placeholder="结束时间"
          >
          </el-date-picker>
        </div>
        <div class="input-li">
          <!-- <p>选择辖区：</p> -->
        </div>
      </div>
      <div class="search-action">
        <el-button
          size="small"
          icon="el-icon-search"
          type="primary"
          @click="getViews()"
          >查询</el-button
        >
        <!-- <el-button size="small" icon="el-icon-refresh" plain @click="onReset()">重置</el-button> -->
      </div>
    </div>
    <div class="chart-content">
      <div class="chart-card">
        <div class="chart-title" style="justify-content: center">
          整体情况统计
        </div>
        <div class="chart-main" id="overall-chart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title" style="justify-content: center">
          行业情况统计
        </div>
        <div class="chart-main" id="industry-chart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title" style="justify-content: center">
          辖区情况统计
        </div>
        <div class="chart-main" id="jurisdiction-chart"></div>
      </div>
      <div class="chart-card">
        <div class="chart-title">
          <el-select
            size="small"
            style="width: 100%"
            clearable
            filterable
            multiple
            collapse-tags
            v-model="companyIds"
            placeholder="请选择企业"
          >
            <el-option
              v-for="item in companies"
              :key="item.companyId"
              :label="item.name"
              :value="item.companyId"
            >
            </el-option>
          </el-select>
          <el-button
            style="margin-left: 10px"
            type="warning"
            size="small"
            @click="getCompanyView()"
            >查询</el-button
          >
        </div>
        <div class="chart-main" id="company-chart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  data() {
    return {
      searchParams: {
        startYear: new Date().getFullYear() - 2 + "",
        endYear: new Date().getFullYear() - 1 + "",
      },
      startDatePicker: {
        disabledDate: (time) => {
          if (this.searchParams.endYear) {
            return time.getFullYear() >= this.searchParams.endYear;
          }
        },
      },
      endDatePicker: {
        disabledDate: (time) => {
          if (this.searchParams.startYear) {
            return time.getFullYear() <= this.searchParams.startYear;
          }
        },
      },
      companyIds: null,
      companies: [],
      overallSituation: [],
      industryData: [],
      industries: [],
      jurisdictionGreen: [],
      companyNames: [],
      companiesGreen: [],
    };
  },
  methods: {
    beginDate() {
      let self = this;
      return {
        disabledDate(time) {
          if (self.searchParams.endYear) {
            let fixedTime = new Date(time);
            return fixedTime.getFullYear() > self.searchParams.endYear;
          }
        },
      };
    },
    // 提出结束时间必须大于提出开始时间
    processDate() {
      let self = this;
      return {
        disabledDate(time) {
          let fixedTime = new Date(time);
          return fixedTime.getFullYear() < self.searchParams.startYear;
        },
      };
    },

    getParams() {
      const url = this.$api.companies.getCompaniesSelect;
      this.$axios.get(url, null, false).then((res) => {
        if (res.data.code == 0) {
          let data = res.data.data;
          this.companies = data;
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },
    getViews() {
      const params = {
        ...this.searchParams,
      };

      const url = this.$api.statistics.getGreenView;

      this.$axios.get(url, params, false).then((res) => {
        if (res.data.code == 0) {
          let {
            overallSituation,
            industryData,
            industries,
            jurisdictionGreen,
            jurisdictions,
          } = res.data.data;

          this.overallSituation = overallSituation;
          this.industryData = industryData;
          this.industries = industries;
          this.jurisdictionGreen = jurisdictionGreen;
          this.jurisdictions = jurisdictions;
          this.drawOverallCharts();
          this.drawIndustryCharts();
          this.drawJurisdictionCharts();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    getCompanyView() {
      if (!document.getElementById("company-chart")) return false;
      echarts.init(document.getElementById("company-chart")).dispose();

      let params2 = {};
      if (this.companyIds && this.companyIds.length > 0) {
        params2.companyIds = this.companyIds.join(",");
        const companyUrl = this.$api.statistics.getCompanyGreenView;
        this.$axios.get(companyUrl, params2, false).then((res) => {
          if (res.data.code == 0) {
            let { companyNames, companiesGreen } = res.data.data;

            this.companyNames = companyNames;
            this.companiesGreen = companiesGreen;
            this.drawCompanyCharts();
          } else {
            this.$message({
              message: "加载数据失败，请重试",
              type: "error",
            });
          }
        });
      }
    },
    drawOverallCharts() {
      let data = this.overallSituation;
      const xData = data.map((d) => d.year);
      const values = data.map((d) => d.value.toFixed(2));
      const legendData = ["园区年度绿色指标"];
      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legendData,
          // left: "16",
          top: "16px",
          //icon: "circle",
          itemWidth: 15, // 设置宽度
          itemHeight: 15, // 设置高度
          itemGap: 25,
          textStyle: {
            // color: '#A0AEC0',
            // fontFamily: 'Source Han Sans CN-Regular',
            // fontSize: 14,
            // padding: [0, 0, 0, 5]
          },
        },
        xAxis: {
          type: "category",
          data: xData,
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            show: true,
          },
        },
        yAxis: {
          type: "value",

          splitLine: {
            show: false,
          },
        },
        series: [
          {
            name: "园区年度绿色指标",
            data: values,
            type: "line",
            smooth: true,
          },
        ],
      };
      const myChart = echarts.init(document.getElementById("overall-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawIndustryCharts() {
      const legendData = this.industries;
      let data = this.industryData;
      let xData = [];
      let seriesData = {};

      data.forEach((yearData) => {
        xData.push(yearData.year);

        legendData.forEach((item) => {
          let da = yearData.value.find((v) => v.name == item);

          if (!seriesData[item]) seriesData[item] = [];

          seriesData[item].push({
            value: da?.value.toFixed(2) || 0,
            yearOutPut: da?.yearOutPut || 0,
            yearOutPutValue: da?.yearOutPutValue || 0,
          });
        });
      });

      let series = [];
      for (let type in seriesData) {
        series.push({
          name: type,
          type: "bar",
          barGap: 0,
          barMaxWidth: 20,
          data: seriesData[type],
          smooth: true,
        });
      }

      let option = {
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: series.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            const { yearOutPut, yearOutPutValue } = params.data;
            const { marker, seriesName } = params;
            return `${marker} ${seriesName} <br /> 
           年度危废产生量：${yearOutPut} 吨 <br /> 
           年度工业产值：${yearOutPutValue} 万元
           `;
          },
          // axisPointer: {
          //   type: "none",
          // },
        },
        legend: {
          data: legendData,
          // align: "right",
          //   right: 10,
          top: "16px",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 35,
          type: "scroll",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          top: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}",
            },
            axisTick: {
              show: false,
            },

            splitLine: {
              show: false,
            },
          },
        ],
        series,
      };
      const myChart = echarts.init(document.getElementById("industry-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawJurisdictionCharts() {
      let data = this.jurisdictionGreen;
      let xData = [];
      let seriesData = {};

      const legendData = this.jurisdictions;
      data.forEach((yearData) => {
        xData.push(yearData.year);

        legendData.forEach((item) => {
          let da = yearData.value.find((v) => v.name == item);

          if (!seriesData[item]) seriesData[item] = [];

          seriesData[item].push({
            value: da?.value.toFixed(2) || 0,
            yearOutPut: da?.yearOutPut || 0,
            yearOutPutValue: da?.yearOutPutValue || 0,
          });
        });

        // yearData.value.forEach(item => {
        //   const { name, value, yearOutPut, yearOutPutValue } = item;
        //   if (!seriesData[name]) seriesData[name] = [];
        //   seriesData[name].push(
        //     { value: value.toFixed(2), yearOutPut, yearOutPutValue })
        // });
      });

      let series = [];
      for (let type in seriesData) {
        series.push({
          name: type,
          type: "bar",
          barGap: 0,
          barMaxWidth: 20,
          data: seriesData[type],
          smooth: true,
        });
      }

      let option = {
        graphic: {
          type: "text", // 类型：文本
          left: "center",
          top: "middle",
          silent: true, // 不响应事件
          invisible: series.length > 0, // 有数据就隐藏
          style: {
            fill: "#9d9d9d",
            fontWeight: "bold",
            text: "暂无数据",
            fontFamily: "Microsoft YaHei",
            fontSize: "25px",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            const { yearOutPut, yearOutPutValue } = params.data;
            const { marker, seriesName } = params;
            return `${marker} ${seriesName} <br /> 
           年度危废产生量：${yearOutPut} 吨 <br /> 
           年度工业产值：${yearOutPutValue} 万元
           `;
          },
          // axisPointer: {
          //   type: "none",
          // },
        },
        legend: {
          data: legendData,
          // align: "right",
          //   right: 10,
          top: "16px",
          itemWidth: 10,
          itemHeight: 10,
          itemGap: 35,
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "8%",
          top: "8%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xData,
            axisLine: {
              show: true,
              lineStyle: {
                width: 1,
                type: "solid",
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "{value}",
            },
            axisTick: {
              show: false,
            },

            splitLine: {
              show: false,
            },
          },
        ],
        series,
      };
      const myChart = echarts.init(
        document.getElementById("jurisdiction-chart")
      );
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    drawCompanyCharts() {
      let data = this.companiesGreen;
      const legendData = this.companyNames;
      let xData = [];
      let seriesData = {};
      data.forEach((yearData) => {
        xData.push(yearData.year);
        legendData.forEach((item) => {
          let da = yearData.value.find((v) => v.name == item);
          if (!seriesData[item]) seriesData[item] = [];

          let val = da?.value?.toFixed(2) || 0;
          seriesData[item].push(val);
        });
      });

      let series = [];
      for (let type in seriesData) {
        series.push({
          name: type,
          type: "line",
          data: seriesData[type],
          smooth: true,
        });
      }
      const option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: legendData,
          top: "16px",
          itemWidth: 15, // 设置宽度
          itemHeight: 15, // 设置高度
          itemGap: 25,
        },
        xAxis: {
          type: "category",
          data: xData,
          splitLine: {
            show: false,
          },
          axisPointer: {
            type: "shadow",
          },
          axisLabel: {
            show: true,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
        },
        series,
      };
      const myChart = echarts.init(document.getElementById("company-chart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  },

  mounted() {
    this.getParams();
    this.getViews();
  },
};
</script>

<style lang="scss" scoped>
.charts {
  height: 100%;
}

.chart-content {
  display: flex;
  flex-wrap: wrap;
  height: calc(100% - 60px);

  .chart-card {
    border: 1px solid #909399;
    width: 46%;
    margin: 10px 1%;
    height: calc(50% - 30px);
    border-radius: 3px;

    .chart-title {
      width: 100%;

      height: 45px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      border-bottom: 1px solid #909399;
      padding: 0px 10px;
    }

    .chart-main {
      width: 100%;
      height: calc(100% - 45px);
    }
  }
}

.select-searchmain1 {
  width: 100%;
  height: 50px;
  display: flex;
  padding: 5px;
  box-sizing: content-box;

  .search-action {
    display: inline-block;
    // width: 230px;
    text-align: center;
    height: 100%;

    margin-right: 10px;
    // line-height: 70px;
  }

  .earch-input {
    flex-grow: 1;
    padding-left: 20px;

    p {
      width: 100%;
      height: 30px;
      line-height: 30px;
    }

    .input-li2 {
      margin-right: 20px;
      width: 350px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }

    .input-li {
      margin-right: 20px;
      width: 200px;
      font-size: 12px;
      display: inline-block;

      .el-input {
        line-height: 40px;
      }
    }
  }
}
</style>
